import { onlyAlphaNumeric } from '@/utils/format-string-only-alpha-numeric';
import { formatStringOnlyNumbers } from '@/utils/format-string-only-numbers';

export const removeMaskDocument = (document: string) => {
  const isCpf = onlyAlphaNumeric(document).length === 11 && formatStringOnlyNumbers(document).length === 11;

  if (isCpf) {
    return formatStringOnlyNumbers(document);
  }
  return onlyAlphaNumeric(document);
};
